import React, { ReactElement } from 'react'

import { NextPage } from 'app/types/decalarations/next'

import MainLayout from '~/components/layouts/MainLayout'
import GetAppView from '~/views/GetAppView'

const GetAppPage: NextPage = () => <GetAppView />

GetAppPage.getLayout = (page: ReactElement) => <MainLayout>{page}</MainLayout>

GetAppPage.getMeta = (intl) => ({
  title: intl.formatMessage({
    defaultMessage: 'Buy Smart, Sell Fast – All in One App'
  }),
  description: intl.formatMessage({
    defaultMessage:
      'Find, buy, and sell your auto parts in a dedicated marketplace app. Our innovative app helps you trade instantly.'
  })
})

export default GetAppPage
